import React from "react";

const Button = ({ children, disabled, ...rest }) => {
  const baseClassName = [
    "relative flex items-center justify-center gap-2 bg-dark-blue-100 text-white text-sl font-notosans font-bold leading-normal rounded-2xl w-[180px] px-4 py-3 transition-all duration-200",
    !disabled && "hover:bg-dark-blue-hover cursor-pointer",
    disabled && "cursor-not-allowed",
    rest.className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button {...rest} disabled={disabled} className={baseClassName}>
      {children}
      {disabled && (
        <div className="absolute inset-0 bg-gray-500 bg-opacity-50 rounded-2xl flex items-center justify-center">
          <div className="w-6 h-6 border-2 border-white border-opacity-30 rounded-full flex items-center justify-center">
            <div className="w-3 h-0.5 bg-white bg-opacity-60 rounded"></div>
          </div>
        </div>
      )}
    </button>
  );
};

export default Button;